module.exports = __webpack_public_path__ + "img/ccl_gallery3.1fccc470.jpg";